export default "__VITE_ASSET__D_U8$UPE__"